import { ConfigInterface } from 'swr';
import { ResponsePromise } from 'ky';
import { wpApi, useWPApi, QueryParams, parseUrl } from '@gik/core/api';
import WordpressLegal from '@gik/core/models/wordpress/WordpressLegal';

const path = 'pages';
const privacySlug = 'privacy-policy';
const termsSlug = 'terms-of-use';

function getParams(slug: string): QueryParams {
  return {
    slug,
  };
}

// general
function getLegal(slug: string) {
  const finalUrl = parseUrl(path, {
    searchParams: getParams(slug),
  });

  const apiResponse: ResponsePromise = wpApi.get(finalUrl);
  return apiResponse.json<WordpressLegal[]>();
}

function useLegal(shouldRun: boolean, slug: string, config?: ConfigInterface) {
  return useWPApi<WordpressLegal[]>(shouldRun ? path : null, config, { searchParams: getParams(slug) });
}

// privacy
export function getPrivacyPolicy() {
  return getLegal(privacySlug);
}

export function usePrivacyPolicy(shouldRun = true, config?: ConfigInterface) {
  return useLegal(shouldRun, privacySlug, config);
}

// terms
export function getTerms() {
  return getLegal(termsSlug);
}

export function useTerms(shouldRun = true, config?: ConfigInterface) {
  return useLegal(shouldRun, termsSlug, config);
}
